import { ICellRendererParams } from 'ag-grid-community'
import { ProgressReportTableContent } from '../table/ProgressReportTable'
import styled from 'styled-components'
import { ReportStatusIcon } from '../status-icon'

export const ReportStatusCellRenderer = (
  params: ICellRendererParams<ProgressReportTableContent>
) => {
  const content = params.data!
  return (
    <StatusIcon>
      <ReportStatusIcon status={content.status} />
    </StatusIcon>
  )
}

const StatusIcon = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  width: '100%',
})
